import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import AppLogo from '@/components/ui/AppLogo/AppLogo.tsx';
import { PropsWithClassName } from '@/types/PropsWithClassName';

const BrandCardSideContent: FC<PropsWithChildren<PropsWithClassName>> = ({ children, className }) => {
  return (
    <div
      className={cn(
        'grid grid-cols-2 shadow-xl rounded-2xl overflow-hidden max-w-full w-[1048px] md:min-h-[500px] lg:min-h-[624px]',
        className
      )}
    >
      <div className="col-span-2 md:col-span-1 flex items-center justify-center p-8 bg-white rounded-l-2xl rounded-r-2xl md:rounded-r-none">
        <AppLogo.LogoOnly className="w-[75px] md:w-[200px] max-w-full" />
      </div>
      <div className="col-span-2 md:col-span-1 flex flex-col justify-center items-center bg-primary-gray-bg gap-4 p-4 lg:p-10">
        {children}
      </div>
    </div>
  );
};

export default BrandCardSideContent;
